import posthog from 'posthog-js';
/**
 * PostHog product analytics + session replay.
 *
 * Conventions: proposals/17-posthog-conventions.md
 *   §1  single project (249682, EU cloud), separated by an `env` property
 *   §2  env / app / release super-properties, registered once after init
 *   §3  capture key seeded in SSM -> deploy workflow -> __POSTHOG_KEY__ (never committed to .env)
 *   §4  session-replay masking floor + Cognito-`sub` identity (see usePostHogIdentify)
 *   §5/§6  $exception capture stays OFF until the Sentry-vs-PostHog decision lands
 *
 * __POSTHOG_KEY__ / __POSTHOG_ENV__ / __GIT_SHA__ are webpack DefinePlugin constants
 * (config/build/buildPlugins.ts). The key comes from process.env.POSTHOG_KEY, exported by
 * ops-workflows/amplify-deploy.yml from SSM /<env>/obs/posthog/project-key. Until that
 * parameter is seeded the key is '' and init is skipped (default-off, §7.4 / DL1).
 */
const POSTHOG_KEY = __POSTHOG_KEY__;
export const posthogEnabled = Boolean(POSTHOG_KEY);
if (posthogEnabled) {
    posthog.init(POSTHOG_KEY, {
        api_host: 'https://eu.i.posthog.com',
        // Autocapture + $pageview stay ON (§2). Error/exception autocapture stays OFF until §6 is
        // decided (§5 gate item 4). (Sentry is only an unused devDependency in this repo today.)
        capture_exceptions: false,
        person_profiles: 'identified_only',
        // Session-replay masking floor — REQUIRED (§4). Take-off documents, DXF drawings and BOQ
        // tables are customer property: every DXF viewer / canvas / document surface must carry
        // data-ph-block, and every field that can hold a customer name or address, data-ph-mask.
        session_recording: {
            maskAllInputs: true,
            maskTextSelector: '[data-ph-mask]',
            blockSelector: '[data-ph-block]'
        }
    });
    // Super-properties on every event including $pageview (§2 rules 3 & 5).
    posthog.register({
        env: __POSTHOG_ENV__, // dev | prod — from the deploy workflow, not process.env.ENV (§0.3)
        app: 'takeoff-ui', //   catalogue entry name (§2 rule 5)
        release: __GIT_SHA__ //  git SHA — matches Sentry's release convention
    });
}
export default posthog;
